import { Slide } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { WModal } from '../../wrappers/wrapper';
import EditProfile from '../edit-profile/edit-profile';
import AuthenticationProfile from '../authentication-profile/authentication-profile';
import Notifications from '../profile-notifications/profile-notifications';
import styles from './profile-dialog.module.scss';
import Button from 'components/atoms/button/button';
import useDeviceType from 'custom-hooks/useDeviceType';

interface ProfileDialogProps {
  open: boolean;
  onClose: () => void;
  activeTab: number;
  onTabChange: (index: number) => void;
}

function ProfileDialog({ open, onClose, activeTab, onTabChange }: ProfileDialogProps) {
  const { isDesktop } = useDeviceType();

  const tabs = [
    { label: 'Profile', content: <EditProfile onClose={onClose} /> },
    { label: 'Notifications', content: <Notifications /> },
    { label: 'Authentication', content: <AuthenticationProfile /> },
  ];

  const renderTabs = () => (
    <div className={styles.nav}>
      {tabs.map((tab, index) => (
        <Button
          type="base"
          key={index}
          className={`${styles.navItem} ${activeTab === index && styles.activetab}`}
          onClick={() => onTabChange(index)}
        >
          {tab.label}
        </Button>
      ))}
    </div>
  );

  return (
    <WModal open={open} onClose={onClose}>
      <Slide in={open} direction="up" mountOnEnter unmountOnExit>
        <div className={styles.container}>
          <div className={styles.header}>
            <div className={styles.top}>
              <span className={styles.title}>Account settings</span>
              {isDesktop && renderTabs()}
              <div className={styles.close}>
                <Button type="base" onClick={onClose}>
                  <CloseIcon style={{color:"var(--color-white)"}} fontSize="small" />
                </Button>
              </div>
            </div>
            {!isDesktop && renderTabs()}
          </div>
          <div className={styles.content}>{tabs[activeTab].content}</div>
        </div>
      </Slide>
    </WModal>
  );
}

export default ProfileDialog;
